import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchTeam } from "../../Redux/WebsiteSlice";
import { useBookingModal } from "../../context/BookingModalContext";
import { getImageUrl } from "../../services/api";
import { stripHtml } from "../../Utils/stripHtml";
import PageAboutSection from "../Shared/PageAboutSection";
import Reveal from "../Shared/Reveal";
import "./OurTeam.scss";

const OurTeam = () => {
  const dispatch = useDispatch();
  const team = useSelector((state) => state.website.team);
  const { openModal } = useBookingModal();

  useEffect(() => {
    dispatch(fetchTeam());
  }, [dispatch]);

  return (
    <div className="page-our-team">
      <div className="page-hero">
        <div className="page-hero__content">
          <span className="small__text">MEET THE TEAM</span>
          <h1 className="headline__text">
            Our <span>Expert Team</span>
          </h1>
          <p className="page-hero__subtitle">
            Our dedicated team of healthcare professionals is committed to providing the highest quality, personalised care.
          </p>
        </div>
      </div>

      <PageAboutSection
        pageKey="ourTeam"
        fallbackHeading="Meet the People Behind Your Care"
        fallbackParagraph="Our team of dedicated healthcare professionals brings years of experience and a genuine passion for helping you move and feel better."
      />

      <section className="compSection comp_our_team">
        <div className="custom_container">
          <div className="row row--team">
            {team && team.length > 0 ? (
              <Reveal as="div" direction="up" className="team__grid">
                {team.map((member) => (
                  <Link
                    key={member._id}
                    to={`/our-team/${member.slug || member._id}`}
                    className="team__card"
                  >
                    <div className="team__card__image">
                      {member.image ? (
                        <img
                          src={getImageUrl(member.image)}
                          alt={member.name}
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.parentElement.classList.add(
                              "team__card__image--placeholder"
                            );
                          }}
                        />
                      ) : (
                        <div className="team__card__placeholder">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="team__card__content">
                      <h4 className="team__card__name">{member.name}</h4>
                      {member.role && (
                        <p className="team__card__role">{member.role}</p>
                      )}
                      {(member.bioPreview || member.bio) && (
                        <p className="team__card__bio">{member.bioPreview || stripHtml(member.bio)}</p>
                      )}
                    </div>
                  </Link>
                ))}
              </Reveal>
            ) : (
              <div className="team-empty">
                <p>Team information coming soon.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <div className="team-cta">
        <Reveal as="div" direction="up" className="team-cta__inner">
          <h2>Ready to book with one of our team?</h2>
          <p>Our practitioners are here to help you get back to feeling your best.</p>
          <button
            type="button"
            onClick={() => setTimeout(openModal, 0)}
            className="site__button site__button_style--solid site__button_shape--default"
          >
            <span className="text">Book an Appointment</span>
          </button>
        </Reveal>
      </div>
    </div>
  );
};

export default OurTeam;
